import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './GrowthStory.css';

// Import your images
import img1 from '../../Assets/GrwthStry/img1.webp';
import img2 from '../../Assets/GrwthStry/img2.webp';
import img3 from '../../Assets/GrwthStry/img3.webp';
import img4 from '../../Assets/GrwthStry/img4.webp';

// Import your arrow icons
import arrowUp from '../../Assets/GrwthStry/arrow.webp'; 
import arrowDown from '../../Assets/GrwthStry/arrowdown.webp';

const milestones = [
  {
    id: "01",
    title: "Established in 1982",
    desc: "Founded with a clear focus on automobile logistics, Janta Roadways began its journey delivering reliable vehicle transportation solutions across India.",
    img: img1,
    cardTitle: "A Legacy Built on Reliability",
    cardDesc:"Founded in 1982, Janta Roadways began its journey with a focused vision to deliver reliable automobile logistics solutions."
  },
  {
    id: "02",
    title: "Trusted Automobile Logistics Partner",
    desc: "Over the years, Janta Roadways has built long-standing partnerships with leading automobile OEMs, supporting passenger and commercial vehicle movement nationwide.",
    img: img2,
    cardTitle: "Trusted by Leading Automobile OEMs",
    cardDesc:"Janta Roadways has built long-standing partnerships with leading automobile manufacturers, supporting the transportation of passenger and commercial vehicles across India."
  },
  {
    id: "03",
    title: "Expansion of Specialised Fleet",
    desc: "Developed a strong owned fleet of specialised car carriers and heavy transport vehicles, enabling safe and compliant movement of automobiles, chassis, and ODC cargo.",
    img: img3,
    cardTitle: "Specialised Fleet for Complex Transport Needs",
    cardDesc:"The company operates a strong owned fleet of specialised car carriers and heavy transport vehicles, enabling safe movement of heavy equipment."
  },
  {
    id: "04",
    title: "Pan-India Operations",
    desc: "Expanded operations across key industrial regions in India, supported by available vehicles, regional offices, and dedicated operations teams.",
    img: img4,
    cardTitle: "Nationwide Reach, Local Execution",
    cardDesc:"With operations spanning key industrial regions across India, Janta Roadways delivers seamless logistics support."
  }
];

const GrowthStory = () => {
  const [activeTab, setActiveTab] = useState(1); // 02 active by default

  return (
    <section className="growth-section py-5">
      <Container>
        <div className="header-box mb-5 text-start">
          <span className="growth-label">OUR GROWTH STORY</span>
          <div className="d-flex justify-content-between align-items-end flex-wrap gap-3 mt-2">
            <h2 className="section-main-title">Our Milestones & Achievements</h2>
            <p className="section-sub-title">Four Decades of Consistent Growth and Operational Excellence</p>
          </div>
        </div>

        <div className="milestone-container">
          {milestones.map((item, index) => (
            <div 
              key={item.id} 
              className={`milestone-wrapper ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              <div className="milestone-header-row">
                <span className="milestone-number">{item.id}</span>
                <h4 className="milestone-title">{item.title}</h4>
                <p className="milestone-desc-inline">{item.desc}</p>
                
                {/* ICON COLUMN */}
                <div className="milestone-icon-wrapper">
                  <img 
                    src={activeTab === index ? arrowDown : arrowUp} 
                    alt="toggle-icon" 
                    className="milestone-arrow-icon"
                  />
                </div>
              </div>

              <div className={`milestone-content-fold ${activeTab === index ? 'open' : ''}`}>
                <div className="growth-card-container" style={{ backgroundImage: `url(${item.img})` }}>
                  <div className="growth-card-overlay">
                    <div className="growth-card-info-box">
                      <h3 className="card-inner-title">{item.cardTitle}</h3>
                      <p className="card-inner-text">{item.cardDesc}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default GrowthStory;